var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-spin-article small-table"},[_c('Table',{attrs:{"loading":_vm.loading,"columns":_vm.columns,"data":_vm.data},on:{"on-sort-change":_vm.changeSorting,"on-selection-change":_vm.onSelectChange}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-307c04e2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/apps/home/topProductsChart.vue
// module id = null
// module chunks = 